import { gql, useQuery } from '@apollo/client'
import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import { useParams } from 'react-router'

import { TIMELINE_FRAGMENT } from '../constants'
import Create from './Create'
import GanttChart from './GanttChart'
import { TASK_FRAGMENT } from './constants'
import TimelineContext from './context'

const TIMELINE = gql`
  ${TIMELINE_FRAGMENT}
  ${TASK_FRAGMENT}
  query TIMELINE($id: ID!) {
    timeline(id: $id) {
      ...TimelineFragment
      tasks {
        ...TaskFragment
      }
    }
  }
`

function NoTasksFound() {
  const theme = useTheme()

  return (
    <Stack
      sx={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
    >
      <Typography
        sx={{ ...theme.typography.h4, color: theme.palette.text.secondary }}
      >
        No tasks found.
      </Typography>
      <Typography sx={{ color: theme.palette.text.secondary }}>
        <b>Click the + button to add a task.</b>
      </Typography>
    </Stack>
  )
}

function Tasks() {
  const { id } = useParams()

  const { loading, error, data } = useQuery(TIMELINE, { variables: { id } })

  if (loading)
    return (
      <Stack
        sx={{ alignItems: 'center', justifyContent: 'center', height: '100%' }}
      >
        <CircularProgress />
      </Stack>
    )
  if (error) return <p>error...</p>

  const { timeline } = data

  return (
    <TimelineContext.Provider value={{ timeline }}>
      <Box sx={{ p: 1, position: 'relative', height: '100%' }}>
        <Create />
        {timeline.tasks.length ? <GanttChart /> : <NoTasksFound />}
      </Box>
    </TimelineContext.Provider>
  )
}

export default Tasks
